export default "__VITE_ASSET__QTmVYtwI__"